import {styled} from "@mui/material/styles";
import {AlertGeneric} from "../CustomAlert.styles";

export const AlertSuccessStyle = styled(AlertGeneric)(({theme}) => ({
    backgroundColor: theme.palette.success.light,
    borderColor: theme.palette.success.main,
    color: theme.palette.success.main,
}));